import './Sidebar.scss';
import React, { useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  RiHotelLine,
  RiRestaurant2Fill,
  RiPaletteLine,
  RiArrowDownSLine,
  RiCodeSSlashLine,
  RiCustomerService2Line,
  RiStarLine,
  RiMoneyEuroCircleLine,
  RiGlobalLine,
  RiShieldKeyholeLine,
  RiRobot2Line,
} from 'react-icons/ri';
import { AuthContext } from '../../contexts/AuthContext';

import { ReactComponent as Alert } from '../../assets/alert-octagon.svg';
import { ReactComponent as Align } from '../../assets/align-center.svg';
import { ReactComponent as Settings } from '../../assets/settings.svg';
import { ReactComponent as Message } from '../../assets/message-square.svg';
import { ReactComponent as Database } from '../../assets/database.svg';
import { ReactComponent as Layers } from '../../assets/layers.svg';
import { ReactComponent as Users } from '../../assets/users.svg';
import { ReactComponent as Table } from '../../assets/table.svg';
import { ReactComponent as Key } from '../../assets/key.svg';
import { ReactComponent as Disc } from '../../assets/disc.svg';
import { ReactComponent as Headphones } from '../../assets/headphones.svg';
import { ReactComponent as BookOpen } from '../../assets/book-open.svg';
import { ReactComponent as Upload } from '../../assets/upload.svg';
import { ReactComponent as Mail } from '../../assets/mail.svg';
import { ReactComponent as Refresh } from '../../assets/refresh-ccw.svg';
import { ReactComponent as Grid } from '../../assets/grid.svg';

export default function Header({ collapsed = false, onNavClick }) {
  const { logout, currentUser } = useContext(AuthContext);
  //const [open, setOpen] = useState(false);

  const [settingsOpen, setSettingsOpen] = useState(true);

  const perms = currentUser?.role || [];
  const isSuper = perms === 'superadmin';
  const isGroup = perms === 'group_admin';
  const isHotel = perms === 'hotel_admin';
  const isOperator = perms === 'operator';

  const today = new Date();
  const year = today.getFullYear();

  const handleItemClick = () => {
    if (typeof onNavClick == 'function') {
      onNavClick();
    }
  };

  return (
    <>
      <aside className={`aside-header ${collapsed ? 'collapsed' : 'expanded'}`}>
        <nav className="navigation">
          {(isHotel || isGroup || isOperator) && (
            <NavLink
              onClick={handleItemClick}
              to="/my-atendimento"
              className="navlink"
            >
              <RiCustomerService2Line size={15} />
              <span>Atendimento</span>
            </NavLink>
          )}

          {(isHotel || isGroup) && (
            <>
              <NavLink
                onClick={handleItemClick}
                to="/my-dashboard"
                className="navlink"
              >
                <Grid />
                <span>Dashboard</span>
              </NavLink>
              <NavLink
                onClick={handleItemClick}
                to="/my-sessions"
                className="navlink"
              >
                <Align />
                <span>Sessões</span>
              </NavLink>
              <NavLink
                onClick={handleItemClick}
                to="/my-unanswered-messages"
                className="navlink"
              >
                <Alert />
                <span>Sem Resposta</span>
              </NavLink>
              <NavLink
                onClick={handleItemClick}
                to="/my-bookings"
                className="navlink"
              >
                <Layers />
                <span>Reservas</span>
              </NavLink>
              <NavLink
                onClick={handleItemClick}
                to="/my-hotels"
                className="navlink"
              >
                <RiHotelLine size={15} />
                <span>Hotéis</span>
              </NavLink>
              <NavLink
                onClick={handleItemClick}
                to="/my-restaurants"
                className="navlink"
              >
                <RiRestaurant2Fill size={15} />
                <span>Restaurantes</span>
              </NavLink>
              <NavLink
                onClick={handleItemClick}
                to="/my-events"
                className="navlink"
              >
                <Disc />
                <span>Salas de Eventos</span>
              </NavLink>
              <button
                type="button"
                className={`navlink menu-toggle ${settingsOpen ? 'open' : ''}`}
                onClick={() => setSettingsOpen((v) => !v)}
                aria-expanded={settingsOpen}
              >
                <Settings />
                <span>Definições</span>
                <RiArrowDownSLine className="chevron" />
              </button>
              {settingsOpen && (
                <div className="submenu">
                  <NavLink
                    onClick={handleItemClick}
                    to="/my-settings"
                    className="navlink"
                  >
                    <RiPaletteLine size={18} />
                    <span>Branding</span>
                  </NavLink>
                  <NavLink
                    onClick={handleItemClick}
                    to="/handoff-config"
                    className="navlink"
                  >
                    <RiCustomerService2Line size={15} />
                    <span>Configurar Atendimento</span>
                  </NavLink>
                  <NavLink
                    onClick={handleItemClick}
                    to="/csat-config"
                    className="navlink"
                  >
                    <RiStarLine size={15} />
                    <span>Configurar Satisfação</span>
                  </NavLink>
                  <NavLink
                    onClick={handleItemClick}
                    to="/revenue-config"
                    className="navlink"
                  >
                    <RiMoneyEuroCircleLine size={15} />
                    <span>Configurar Upselling</span>
                  </NavLink>
                  <NavLink
                    onClick={handleItemClick}
                    to="/my-chat-topics"
                    className="navlink"
                  >
                    <Database />
                    <span>Tópicos</span>
                  </NavLink>
                  <NavLink
                    onClick={handleItemClick}
                    to="/my-chat-messages"
                    className="navlink"
                  >
                    <Message />
                    <span>Mensagens</span>
                  </NavLink>
                </div>
              )}
            </>
          )}

          {isSuper && (
            <>
              <NavLink
                onClick={handleItemClick}
                to="/dashboard"
                className="navlink"
              >
                <Grid />
                <span>Dashboard</span>
              </NavLink>
              <NavLink
                onClick={handleItemClick}
                to="/sessions"
                className="navlink"
              >
                <Align />
                <span>Sessões</span>
              </NavLink>
              <NavLink
                onClick={handleItemClick}
                to="/unanswered"
                className="navlink"
              >
                <Alert />
                <span>Sem Resposta</span>
              </NavLink>
              <NavLink
                onClick={handleItemClick}
                to="/bookings"
                className="navlink"
              >
                <Layers />
                <span>Reservas</span>
              </NavLink>
              <NavLink
                onClick={handleItemClick}
                to="/groups"
                className="navlink"
              >
                <Grid />
                <span>Grupos</span>
              </NavLink>
              <NavLink
                onClick={handleItemClick}
                to="/hotels"
                className="navlink"
              >
                <RiHotelLine size={15} />
                <span>Hotéis</span>
              </NavLink>
              <NavLink
                onClick={handleItemClick}
                to="/restaurants"
                className="navlink"
              >
                <RiRestaurant2Fill size={15} />
                <span>Restaurantes</span>
              </NavLink>
              <NavLink
                onClick={handleItemClick}
                to="/events"
                className="navlink"
              >
                <Disc />
                <span>Salas de Eventos</span>
              </NavLink>
              <button
                type="button"
                className={`navlink menu-toggle ${settingsOpen ? 'open' : ''}`}
                onClick={() => setSettingsOpen((v) => !v)}
                aria-expanded={settingsOpen}
              >
                <Settings />
                <span>Definições</span>
                <RiArrowDownSLine className="chevron" />
              </button>
              {settingsOpen && (
                <div className="submenu">
                  <NavLink
                    onClick={handleItemClick}
                    to="/settings"
                    className="navlink"
                  >
                    <RiPaletteLine size={18} />
                    <span>Branding</span>
                  </NavLink>
                  <NavLink
                    onClick={handleItemClick}
                    to="/modules"
                    className="navlink super"
                  >
                    <Layers />
                    <span>Módulos - Licença</span>
                  </NavLink>
                  <NavLink
                    onClick={handleItemClick}
                    to="/sync-content"
                    className="navlink super"
                  >
                    <RiGlobalLine size={15} />
                    <span>Sincronização de Conteúdos</span>
                  </NavLink>
                  <NavLink
                    onClick={handleItemClick}
                    to="/licensing"
                    className="navlink super"
                  >
                    <RiShieldKeyholeLine size={15} />
                    <span>Licenciamento</span>
                  </NavLink>
                  <NavLink
                    onClick={handleItemClick}
                    to="/concierge-assistant"
                    className="navlink super"
                  >
                    <RiRobot2Line size={15} />
                    <span>Assistente IA do Concierge</span>
                  </NavLink>
                  <NavLink
                    onClick={handleItemClick}
                    to="/handoff-config"
                    className="navlink"
                  >
                    <RiCustomerService2Line size={15} />
                    <span>Configurar Atendimento</span>
                  </NavLink>
                  <NavLink
                    onClick={handleItemClick}
                    to="/csat-config"
                    className="navlink"
                  >
                    <RiStarLine size={15} />
                    <span>Configurar Satisfação</span>
                  </NavLink>
                  <NavLink
                    onClick={handleItemClick}
                    to="/revenue-config"
                    className="navlink"
                  >
                    <RiMoneyEuroCircleLine size={15} />
                    <span>Configurar Upselling</span>
                  </NavLink>
                  <NavLink
                    onClick={handleItemClick}
                    to="/users"
                    className="navlink super"
                  >
                    <Users />
                    <span>Utilizadores</span>
                  </NavLink>
                  <NavLink
                    onClick={handleItemClick}
                    to="/forms"
                    className="navlink super"
                  >
                    <Table />
                    <span>Formulários</span>
                  </NavLink>
                  <NavLink
                    onClick={handleItemClick}
                    to="/api-keys"
                    className="navlink super"
                  >
                    <Key />
                    <span>Api Keys</span>
                  </NavLink>
                  <NavLink
                    onClick={handleItemClick}
                    to="/show-logs"
                    className="navlink super"
                  >
                    <Refresh />
                    <span>Audit Logs</span>
                  </NavLink>
                  <a
                    href="/editor.html"
                    target="_blank"
                    rel="noreferrer"
                    className="navlink super"
                    onClick={handleItemClick}
                  >
                    <RiCodeSSlashLine size={18} />
                    <span>HTML Editor</span>
                  </a>
                </div>
              )}
            </>
          )}
          <button
            onClick={() => {
              handleItemClick();
              logout();
            }}
            className="logout"
          >
            <Upload style={{ transform: 'rotate(90deg)' }} />
            <span>Terminar sessão</span>
          </button>
        </nav>

        <div className="navbar-footer">
          <div className="links">
            <a href="mailto:comercial@hoteisdigitais.com">
              <Mail />
              <span className="tooltip-text">Suporte</span>
            </a>
            <a href="/help" target="_blank" rel="noreferrer">
              <BookOpen />
              <span className="tooltip-text">Manual do utilizador</span>
            </a>
            <a
              href="https://wa.me/5511999999999"
              target="_blank"
              rel="noreferrer"
            >
              <Headphones />
              <span className="tooltip-text">Whatsapp</span>
            </a>
            <span className="version-badge">v2.1.1</span>
          </div>
          <p className="credits">
            <a
              href="https://hoteisdigitais.com/"
              target="_blank"
              rel="noreferrer"
            >
              HoteisDigitais{' '}
            </a>
            @ {year}. Todos os direitos reservados.
          </p>
        </div>
      </aside>
    </>
  );
}
